export default "/Frontend/dist/word-white.0a39d097f004f6f8a3d795f2c7685cb9.svg";